'use client'

import React from 'react'
import classNames from 'classnames'
import styles from './Typography.module.css'
import { BaseTypographyProps, ResponsiveProps, createCombinedStyles } from './typographyUtils'

export type TaglineVariant = 'tagline-32' | 'tagline-26' | 'regular-26'

export interface TaglineProps extends BaseTypographyProps {
  variant?: TaglineVariant
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span' | 'p'
  responsive?: ResponsiveProps
}

export const Tagline = ({
  children,
  variant = 'tagline-32',
  as: Component = 'h3',
  className = '',
  color,
  responsive,
  style = {},
  ...props
}: TaglineProps) => {
  // Create combined styles using the utility function
  const combinedStyles = createCombinedStyles(style, color, responsive)

  // Use classNames to combine classes
  const combinedClassNames = classNames(styles[variant], className)

  return (
    <Component className={combinedClassNames} style={combinedStyles} {...props}>
      {children}
    </Component>
  )
}

export default Tagline
